import { Box, Paper, Typography, alpha, useTheme, Skeleton } from '@mui/material';
import schoolIcon from '../../assets/school-icon.svg'
import type { SchoolDetails } from '@/types/school';
import axios from 'axios';


interface StatCardProps {
  iconColor: string;
  label: string;
  children: React.ReactNode;
}

function StatCard({ label, children }: StatCardProps) {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        border: `1px solid ${alpha(theme.palette.divider, 1)}`,
        borderRadius: '12px',
        p: 2.5,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        backgroundColor: 'background.paper',
        minWidth: 0,
      }}
    >
      <Box
      component="img"
      src={schoolIcon}
      alt="schoolicon"
        sx={{
          width: 44,
          height: 44,
          borderRadius: '10px'
        }}
      >
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{ color: 'text.secondary', fontWeight: 500, display: 'block', mb: 0.25 }}
        >
          {label}
        </Typography>
        {children}
      </Box>
    </Paper>
  );
}


interface StatsRowProps {
  school?: SchoolDetails;
  isLoading?: boolean;
  error?: unknown;
}

export default function StatsRow({ school, isLoading, error }: StatsRowProps) {
  const theme = useTheme();
  let errorMessage="";
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 422) {
      errorMessage = "Invalid school code entered";
    } else {
      errorMessage = error.message;
    }
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <Box sx={{ mb: 2 }}>
    {/* School Information */}
      <StatCard
        iconColor={theme.palette.primary.main}
        label="School Information"
      >
        {isLoading ? (
          <>
            <Skeleton variant="text" width={140} height={28} />
            <Skeleton variant="text" width={180} height={18} />
          </>
        ) : error ? (
          <Typography variant="body2" color="error">
            {errorMessage}
          </Typography>
        ) : (
          <>
            <Typography variant="h6" fontWeight={700} noWrap>
              {school?.name ?? '—'}
            </Typography>
            <Typography variant="caption" color="text.disabled" noWrap>
              {school?.address ?? '—'}
            </Typography>
          </>
        )}
      </StatCard>
    </Box>
  );
}
